import { ParsingCommentsDataBundlePropType } from "@interfaces/data-type/type.pages-comments";
import {  Dispatch,FoxIcon, StoragesSystem,  } from "index-module";
import React, { Component } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { HeaderGlobal } from "@module-layout/header/index.header.global";
import { FooterGlobal } from "@module-layout/footer/index.footer.global";
import { OwnImage } from "@img/module-images";
import { SkillSets } from "./data/skill-sets";
import { ToolsSets } from "./data/tool-sets";
import { LibSets } from "./data/lib-sets";
import { MyProject } from "./module/MyProject";


export interface ScreenHomePropTypeSmall {
  StoragesSystem: any,
  setStorage?: (obj: ParsingCommentsDataBundlePropType) => void
}

export type ScreenHomePropType = ScreenHomePropTypeSmall & RouteComponentProps;

export interface ScreenHomeStateType {
  catalog: any,
  key: any,
  searchKey: any
}

const ScreenPortofolioDefaultProps : ScreenHomePropTypeSmall = {
  StoragesSystem: {
    catalog: [
    ]
  },
}
const BOTTOM_MENU = [
  {
    icon: 'star-full',
    title: 'Best From The Best',
    detail: 'I can handle anything, from front-end, back-end, system analysis and design ui and ux.'
  },
  {
    icon: 'rocket',
    title: 'Fast Learner',
    detail: 'I can master the latest technology in a relatively short time, without any difficulty in learning it.'
  },
  {
    icon: 'lamp',
    title: 'Criticall Tingker And Problem Solver',
    detail: 'I am a person who thinks critically and is able to solve every problem encountered with a remarkable solution'
  },
]

const MENU = [
  {id: '#about', className: "oneleft onehide-l", label: "About Me"},
  {id: '#skills', className: "oneleft onehide-l", label: "Skills"},
  {id: '#project', className: "oneleft onehide-l", label: "Projects"},
  {id: 'menu', className: "oneright menubtn", label: "", icon: "menu", isMenu: true},
  //{id: 'menu', className: "oneright onehide-l", label: "", icon: "search"},
  {id: 'store', className: "oneright onehide-l", label: "", icon: "foxstore", href: "/ridwan/store"},
  {id: 'foxdreem', className: "oneright onehide-l", label: "Foxdreem", icon: "foxdreem", href: "/"}
]
class ScreenPortofolio extends Component<ScreenHomePropType,  any> {
  static defaultProps = ScreenPortofolioDefaultProps;
  constructor(props: any){
    super(props)
    this.state = {

    }
  }

  logo = () => (
    <a href="/ridwan" className="title titleimg oneleft" hrefLang="en"><img src={OwnImage.RidwanWhite} />
      <label className="title ">
        <span style={{fontWeight: 'bold', color: '#fff'}}>rid</span>
        <span style={{fontWeight: 200}}>wan</span>
        <span className="onetm">fox</span>
      </label>
    </a>
  )
  render(){
    const { props, state } = this;
    return(
      <>
        <HeaderGlobal topMenu = {MENU} logo = {this.logo} / >
          <section>
            <div className="oneboxbanner">
              <div className="onebanner oneleft" style={{backgroundImage: `url(${OwnImage.Back4})`, minHeight: '43em'}}>
                <div style={{height: '100px'}} />
                <div className="oneportoinfo">
                  <div className="imgluar">
                    <img className="img" src={OwnImage.Ridwan} />
                  </div>
                </div>
                <div className="onetitleone onec-white">Hi, Im Ridwan, Im Fullstack App Developer For</div>
                <div className="onetitletwo onec-white"><span className="onetextbox onec-orange">Web Apps</span><span className="onetextbox onec-green">Mobile Apps</span><span className="onetextbox onec-semiorange">Desktop Apps</span><span className="onetextbox onec-blue">Games</span></div>
                <div className="onetitletree onec-white">I have experience on industries over 4th years, If you are interested in a new project, collaboration, or a reason to get a coffee don't hesitate to shoot me an email or by phone</div>
              </div>
            </div>

            <div className="onecol ogray" style={{textAlign: 'center'}} id="about">
              <div className="m1 oneinfo absolute odarkgray ">
                <div className="onetitle onec-blue">More About Me</div>
                <div className="talktome">Hi, my name is Ridwan, i was born on may 5, 1995. I‘m a creative full stack developer for web apps , mobile apps desktop apps and also games, originally from Pekalongan and based in gyakarta with over 7 years of experience in the industry.
                  <p>
                    I am a passionate creative that leads by example with a hands-on approach. I seek to inspire, and build the best work possible. I am a critical thinker and problem solver that takes aholistic approach to every project, making sure every aspect of it gets produced at the highest quality.  I believe that every single line code i’v ever created will make the more better future.
                  </p>
                </div>
              </div>
              <div className="l1 absolute aboutme">
                <div className="containerbox">
                  <div className="l2 oneleft box">
                    <img src={OwnImage.Edu} />
                    <div className="tittle">BACELOR DEGREE OF COMPUTER SCIENCE</div>
                    <div className="line onebg-orange" />
                    <div className="text">I am a graduate of Universitas Teknologi Yogyakarta in 2018 with computer science degree.</div>
                    <div className="subtitle">"Universitas Teknologi Yogyakarta"</div>
                  </div>
                  <div className="l2 oneleft box">
                    <img src={OwnImage.Certified} />
                    <div className="tittle">CERTIFED PROGRAMMING FROM BNSP</div>
                    <div className="line onebg-green" />
                    <div className="text">I'v been certified by BNSP (Indonesian Profesional Certification Authority) for Competence of computer programming on 28 February 2018</div>
                    <div className="subtitle">"BNSP (Indonesian Profesional Certification Authority)"</div>
                  </div>
                </div>
                <div style={{width: '100px', height: '100px', backgroundColor: 'rgb(221,222,204)', transform: 'rotateZ(45deg)', OTransform: 'rotateZ(45deg)', msTransform: 'rotateZ(45deg)', WebkitTransform: 'rotateZ(45deg)', borderRadius: '10px', position: 'absolute', bottom: '-60px', left: '25%'}} />
                <div style={{width: '100px', height: '100px', backgroundColor: 'rgb(221,222,204)', transform: 'rotateZ(45deg)',  OTransform: 'rotateZ(45deg)', msTransform: 'rotateZ(45deg)', WebkitTransform: 'rotateZ(45deg)', borderRadius: '10px', position: 'absolute', bottom: '-60px', left: '40%'}} />	
                <div style={{width: '100px', height: '100px', backgroundColor: 'rgb(221,222,204)', transform: 'rotateZ(45deg)', OTransform: 'rotateZ(45deg)', msTransform: 'rotateZ(45deg)', WebkitTransform: 'rotateZ(45deg)', borderRadius: '10px', position: 'absolute', bottom: '-60px', left: '75%'}} />		
              </div>	
            </div>


            <div className="onecol onebg-white" style={{textAlign: 'center'}}>
              <div className="backimg skills" style={{backgroundImage: `url(${OwnImage.Back2})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-blue">What Do I Haved</div>
                  <div style={{fontSize: '0.7em'}}>I have anything about good think in this body</div>
                </div>
                <div className="l1 absolute personalskills">
                  <div className="centerimg">
                    <div className="backimg img" style={{backgroundImage: `url(${OwnImage.Ridwan})`}} />
                  </div>
                  <div className="l1 content">
                    <div className="l1" style={{overflow: 'hidden'}}>
                      <div className="l2 oneleft itemright">
                        <img className="oneright onebg-white" src={OwnImage.Analityc} />
                        <div className="oneright onec-blue headtext">Good Analitic</div>
                        <div className="oneright foottext">I'v Good anaitic skills </div>
                      </div>
                      <div className="l2 oneleft itemleft">
                        <img className="oneleft onebg-white" src={OwnImage.HardWork} />
                        <div className="oneleft onec-blue headtext">Hard Worker</div>
                        <div className="oneleft foottext">I can work under hight presure</div>
                      </div>
                    </div>
                    <div className="l1" style={{overflow: 'hidden'}}>
                      <div className="l3 oneleft itemright">
                        <img className="oneright onebg-white" src={OwnImage.Fast} />
                        <div className="oneright onec-blue headtext">Fast Learn</div>
                        <div className="oneright foottext">Very fast to learn for new thinks</div>
                      </div>
                      <div className="l3 oneleft itemleft  onehide-l">
                      </div>
                      <div className="l3 oneleft itemleft">
                        <img className="oneleft onebg-white" src={OwnImage.Creative} />
                        <div className="oneleft onec-blue headtext">Creative</div>
                        <div className="oneleft foottext">To be creative is my priority</div>
                      </div>
                    </div>
                    <div className="l1" style={{overflow: 'hidden'}}>
                      <div className="l3 oneleft itemright">
                        <img className="oneright onebg-white" src={OwnImage.Smart} />
                        <div className="oneright onec-blue headtext">Briliant</div>
                        <div className="oneright foottext">Always have briliant idea</div>
                      </div>
                      <div className="l3 oneleft itemright onehide-l">
                      </div>
                      <div className="l3 oneleft itemleft">
                        <img className="oneleft onebg-white" src={OwnImage.Atitude} />
                        <div className="oneleft onec-blue headtext">Good Atitude</div>
                        <div className="oneleft foottext">Has good atitude and personality</div>
                      </div>
                    </div>
                    <div className="l1" style={{overflow: 'hidden'}}>
                      <div className="l2 oneleft itemright">
                        <img className="oneright onebg-white" src={OwnImage.Problem} />
                        <div className="oneright onec-blue headtext">Problem Solver</div>
                        <div className="oneright foottext">Always give the best solution for every problem</div>
                      </div>
                      <div className="l2 oneleft itemleft">
                        <img className="oneleft onebg-white" src={OwnImage.Team} />
                        <div className="oneleft onec-blue headtext">Team or Individu</div>
                        <div className="oneleft foottext">Can work for team or individu</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
            <div className="onecol onebg-semiblack">
              <div className="backimg" style={{backgroundImage: `url(${OwnImage.Back9})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-blue">What Can I Do For You?</div>
                  <div>I can do anything as long as it does not hurting someone else</div>
                </div>
                <div className="onecol absolute" style={{paddingBottom: '80px', overflow: 'hidden', paddingTop: '20px'}}>	
                  <div className="l1 oneleft whatwe fexbox">
                    <div className="xl3 oneleft itemright onebg-purple mar childflex">
                      <FoxIcon icon = {"database"} className="oneicon one-database img onec-blue" style={{fontSize: '5em'}}  />
                      <div className="oneright onec-blue headtext">BACK END</div>
                      <div className="oneright foottext onec-white">Back end, is my daily meal, and I am very good on it.</div>
                    </div>
                    <div className="xl3 oneleft onehide-xl childflex" style={{height: '100%', textAlign: 'center', padding: '0 10px 0 10px', maxHeight: '180px'}}>
                      <div className="onebg-purple" style={{padding: '95px 99px 95px 99px'}}>
                        {/* <div className="logo oneicon one-lamp onec-blue " /> */}
                        <FoxIcon icon = {"lamp"} className="logo oneicon one-lamp onec-blue" style={{fontSize: '5em'}}  />
                      </div>
                    </div>
                    <div className="xl3 oneleft itemleft onebg-purple mar childflex">
                      <FoxIcon icon = {"laptop"} className="oneicon one-laptop img onec-blue" style={{fontSize: '5em'}}  />
                      <div className="oneleft onec-blue headtext">FROND END</div>
                      <div className="oneleft foottext onec-white">front-end is my face, I am used to creating front end for mobile apps, desktop apps and web apps</div>
                    </div>
                    <div className="xl3 oneleft itemright onebg-ungu mar childflex">
                      {/* <div className="oneicon one-user-tie img onec-blue" /> */}
                      <FoxIcon icon = {"user-tie"} className="oneicon one-laptop img onec-blue" style={{fontSize: '5em'}}  />
                      <div className="oneright onec-blue headtext">UI/UX DESIGN</div>
                      <div className="oneright foottext onec-white">I am the master of UI and UX design for every single apps</div>
                    </div>
                    <div className="xl3 oneleft itemleft onehide-xl mar childflex">
                    </div>
                    <div className="xl3 oneright itemleft onebg-ungu mar childflex">
                      {/* <div className="oneicon one-cabinet img onec-blue" /> */}
                      <FoxIcon icon = {"cabinet"} className="oneicon one-laptop img onec-blue" style={{fontSize: '5em'}}  />
                      <div className="oneleft onec-blue headtext">DATABASE DESIGN</div>
                      <div className="oneleft foottext onec-white">Im expert on database design, its very easy.</div>
                    </div>
                    <div className="xl3 oneleft itemright onebg-purple mar childflex">
                      {/* <div className="oneicon one-gamepad img onec-blue" /> */}
                      <FoxIcon icon = {"gamepad"} className="oneicon one-laptop img onec-blue" style={{fontSize: '5em'}}  />
                      <div className="oneright onec-blue headtext">GAME DESIGN AND PROGRAMMER</div>
                      <div className="oneright foottext onec-white">I Like make games, its kind like  flowing my blood, i always dream to make great game like limbo</div>
                    </div>
                    <div className="xl3 oneleft itemleft onehide-xl mar childflex">
                      <div style={{padding: '10px', textAlign: 'center', fontSize: '1.7em', paddingTop: '20px'}} className="childflex onec-blue">
                        Yeah, Its Me.
                      </div>
                    </div>
                    <div className="xl3 oneright itemleft onebg-purple mar childflex">
                      {/* <div className="oneicon one-bug img onec-blue" /> */}
                      <FoxIcon icon = {"bug"} className="oneicon one-laptop img onec-blue" style={{fontSize: '5em'}}  />
                      <div className="oneleft onec-blue headtext">BUG FIGHTER</div>
                      <div className="oneleft foottext onec-white">I'm very happy to fight with bugs, it's kind like my favorite things to do</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className="onecol" id="skills">
              <div className="backimg after" style={{backgroundImage: `url(${OwnImage.Back8})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-blue">Programming Language Skills</div>
                  <div className="onec-white">I can code on many programming language, and expert on many of them</div>
                </div>
                <div className="oneuser onecol absolute fexbox" id="programmingskill">
                  { SkillSets.map((item, i) => (
                    <div className="item box4 oneleft" key={i}>
                      <FoxIcon icon = {item.icon} className={`icon oneicon ${item.color}`} style = {{fontSize: '5.3em', padding: '25px', borderRadius: '50%'}}  />
                      <div className="tittle">{item.title}</div>
                      <div className="text">{item.text?.ucwords?.()}</div>
                      <div className="text onec-ungu" style={{fontWeight: 'bold'}}>{item.status?.toUpperCase?.()}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>


            <div className="onecol onebg-white">
              <div className="m1 oneinfo">
                <div className="onetitle onec-blue">Framework and Code Library Skills</div>
                <div>To improve productivity, I also use some libraries</div>
              </div>
              <div className="onebg-white oneuser onecol fexbox">	
                { LibSets.map((item, i) => (
                  <div className="item box4 oneleft" key={i}>
                    <FoxIcon icon = {item.icon} className={`icon oneicon ${item.color}`} style = {{fontSize: '5.3em', padding: '25px', borderRadius: '50%'}}  />
                    <div className="tittle">{item.title}</div>
                    <div className="text">{item.text?.ucwords?.()}</div>
                    <div className="text onec-ungu" style={{fontWeight: 'bold'}}>{item.status?.toUpperCase?.()}</div>
                  </div>
                ))}	
              </div>
            </div>
            

            <div className="onecol">
              <div className="backimg" style={{backgroundImage: `url(${OwnImage.Back2})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-blue">TOOLS SKILLS</div>
                  <div>I like with some tools that I use in developing Apps</div>
                </div>
                <div className="oneuser onecol absolute fexbox" id="toolskill">			
                  { ToolsSets.map((item, i) => (
                    <div className="item box4 oneleft" key={i}>
                      <FoxIcon icon = {item.icon} className={`icon oneicon ${item.color}`} style = {{fontSize: '5.3em', padding: '25px', borderRadius: '50%'}}  />
                      <div className="tittle">{item.title}</div>
                      <div className="text">{item.text?.ucwords?.()}</div>
                      <div className="text onec-ungu" style={{fontWeight: 'bold'}}>{item.status?.toUpperCase?.()}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="onecol onebg-semiblack" id="project">
              <div className="backimg after onecontainer" style={{backgroundImage: `url(${OwnImage.Back8})`}}>
                <div className="m1 oneinfo absolute">
                  <div className="onetitle onec-blue">All Project I'v made</div>
                  <div>Almost All Apps, Im Created Using Web Technology And Java</div>
                </div>
                <div className="onecol apps absolute fexbox " id="apps_client">
                  <MyProject /> 
                </div>
                <div className="onecontainer btnmore absolute">
                  <label>Get More Apps</label><a className="oneclick-orange  mar-side onehover" href="/ridwan/store/">VIEW ALL</a> 
                </div>
              </div>
            </div>


          </section>
        <FooterGlobal {...props}  bottomMenu = {BOTTOM_MENU} title = {"Why Choose Me"} />
      </>
    )
  }
}

const mapStateToProps = (state: any) => ({
  StoragesSystem: state.StoragesSystem,
})
const mapDispatchToProps = (dispatch: Dispatch ) => ({
  setStorage: ({ data, type }: ParsingCommentsDataBundlePropType) => dispatch( new StoragesSystem().setStorage({ data, type }) ),
})

export default withRouter(connect( mapStateToProps, mapDispatchToProps )( ScreenPortofolio ));
